import { AUTH_ADDRESS } from "../../constants/api-constants";
import { normalizeAUMobileNumber } from "../validators/mobile-number-validator";

const getMobileFromProfile = (data = {}) => {
    const { userProfiles = [] } =  data;
    const mobileObj = userProfiles.find(obj => obj.addressType === AUTH_ADDRESS.PHONE); // look for first instance
    return mobileObj ? normalizeAUMobileNumber(mobileObj.address) : "";
};

export default getMobileFromProfile;
